import { a as y } from "../../../vee-validate.esm-c4518011.js";
import { defineComponent as w, resolveComponent as h, openBlock as o, createElementBlock as l, normalizeClass as g, createVNode as k, createCommentVNode as d, createElementVNode as a, createBlock as c, toDisplayString as m } from "vue";
import v from "../VIcon/VIcon.js";
import { V } from "../../../VImage-b57fd9d1.js";
import { _ as S } from "../../../_plugin-vue_export-helper-dad06003.js";
var p = /* @__PURE__ */ ((e) => (e.ICON_LIBRARY = "iconLibrary", e.ABSOLUTE_PATH = "absolutePath", e.SYMBOL = "symbol", e))(p || {});
const C = new RegExp("[./]"), _ = new RegExp("^/assets/icons.+(.svg)"), I = (e) => {
  if (!(e === "" || e === null || e === void 0))
    return C.test(e) ? _.test(e) ? "iconLibrary" : "absolutePath" : "symbol";
}, R = w({
  name: "VFormRadioCheckboxCard",
  components: { VIcon: v, VImage: V },
  emits: ["change", "update:modelValue"],
  inheritAttrs: !1,
  props: {
    id: {
      type: String,
      default: ""
    },
    header: {
      type: String,
      default: ""
    },
    subline: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [String, Boolean],
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "radio"
    },
    rules: {
      type: Function,
      default: () => !0
    },
    labelSize: {
      type: String,
      default: "m"
    },
    icon: {
      type: String,
      default: "nav-new-inquiry"
    }
  },
  setup(e, n) {
    const r = {
      uncheckedValue: "",
      validateOnMount: !1
    }, u = I(e.icon), { handleChange: s } = y(e.name, e.rules, {
      validateOnMount: r.validateOnMount,
      uncheckedValue: r.uncheckedValue,
      type: e.type,
      valueProp: e.value
    });
    return s(e.modelValue), {
      config: r,
      onChange: (t) => {
        let i = t.target.value;
        t.target.checked || (i = ""), s(i), n.emit("change", t);
      },
      iconReferenceType: u,
      IconReferenceType: p
    };
  },
  computed: {
    isSelected() {
      return Array.isArray(this.modelValue) ? this.modelValue.includes(this.value) : this.modelValue === this.value;
    }
  }
});
const B = {
  key: 0,
  class: "hobi-form-radio-checkbox-card-checkbox tw-w-6 tw-h-6 tw-absolute tw-top-0 tw-right-0 tw-bg-orange tw-text-center"
}, T = ["for"], A = ["type", "id", "name", "value", "v-model", "checked", "aria-describedby", "data-testid"], L = { class: "hobi-form-radio-checkbox-card-content-wrapper tw-flex tw-p-4 tw-m-0 tw-cursor-pointer" }, O = { class: "hobi-form-radio-checkbox-card-icon tw-pr-5" }, x = { class: "hobi-form-radio-checkbox-card-content tw-flex tw-self-center tw-flex-col" }, z = { class: "hobi-form-radio-checkbox-card-header tw-font-obi-bold tw-not-italic tw-text-lg tw-text-gray-900 tw-pr-4" }, E = {
  key: 0,
  class: "hobi-form-radio-checkbox-card-subline tw-font-sans tw-not-italic tw-font-normal tw-text-base tw-text-gray-900 tw-pt-2"
};
function P(e, n, r, u, s, b) {
  const t = h("VIcon"), i = h("VImage");
  return o(), l("div", {
    class: g([
      "hobi-form-radio-checkbox-card tw-relative tw-rounded tw-cursor-pointer",
      e.isSelected ? "hobi-form-radio-checkbox-card-checked tw-border-2 tw-border-solid tw-border-orange" : "tw-border tw-border-solid tw-border-gray-300"
    ])
  }, [
    e.isSelected ? (o(), l("div", B, [
      k(t, {
        symbol: "checkmark",
        size: "16",
        class: "check-icon tw-text-white"
      })
    ])) : d("", !0),
    a("label", { for: e.id }, [
      a("input", {
        type: e.type,
        id: e.id,
        name: e.name,
        value: e.value,
        "v-model": e.modelValue,
        checked: e.isSelected,
        class: "hobi-visually-hidden",
        "aria-describedby": `hobi-${e.name}-error-message`,
        "data-testid": e.name,
        onChange: n[0] || (n[0] = (...f) => e.onChange && e.onChange(...f))
      }, null, 40, A),
      a("p", L, [
        a("span", O, [
          e.iconReferenceType === e.IconReferenceType.ICON_LIBRARY ? (o(), c(t, {
            key: 0,
            class: "hobi-icon",
            symbol: void 0,
            url: e.icon,
            baseUrl: "",
            size: "40",
            "view-box": "0 0 40 40"
          }, null, 8, ["url"])) : e.iconReferenceType === e.IconReferenceType.ABSOLUTE_PATH ? (o(), c(i, {
            key: 1,
            image: e.icon,
            optimize: !1,
            width: "40px",
            height: "40px"
          }, null, 8, ["image"])) : e.iconReferenceType === e.IconReferenceType.SYMBOL ? (o(), c(t, {
            key: 2,
            class: "hobi-icon",
            symbol: e.icon,
            size: "40",
            "view-box": "0 0 40 40"
          }, null, 8, ["symbol"])) : d("", !0)
        ]),
        a("span", x, [
          a("span", z, m(e.header), 1),
          e.subline ? (o(), l("span", E, m(e.subline), 1)) : d("", !0)
        ])
      ])
    ], 8, T)
  ], 2);
}
const U = /* @__PURE__ */ S(R, [["render", P], ["__scopeId", "data-v-327ed649"]]);
export {
  U as default
};
